import { createContext, useContext } from "react";

// Joyride owns the tooltip's props, so the only way to tell it whether the
// current stop has been carried out is out of band
const TourGateContext = createContext(null);

export const TourGateProvider = ({ value, children }) => (
   <TourGateContext.Provider value={value}>{children}</TourGateContext.Provider>
);

export const useTourGate = () => useContext(TourGateContext);

export default TourGateContext;
